import { render, staticRenderFns } from "./ListFormatWrap.vue?vue&type=template&id=5d6e7cc0&"
import script from "./ListFormatWrap.vue?vue&type=script&lang=js&"
export * from "./ListFormatWrap.vue?vue&type=script&lang=js&"
import style0 from "./ListFormatWrap.vue?vue&type=style&index=0&id=5d6e7cc0&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports